import React, { Component } from "react";

import "./Popup.scss"

class Popup extends Component {
    constructor() {
        super()
        this.state = {
        }
        this.close = this.close.bind(this);
    }
    close() {
        this.props.triggerPopup();
    }
    render() {
        return (
            <div>
                <div className={`popupfade${(this.props.isPoping ? " active" : "")}`} onClick={this.close}></div>
                <section className={`section section-popup${(this.props.isPoping ? " active" : "")}`} onClick={this.close}>
                    <div className="padding">
                        <div className="container">
                            {/* <div className="close"></div> */}
                            <div className="headline">
                                <div className="head"></div>
                                <div className="desc">{this.props.popupData.Title}</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Popup;



// WEBPACK FOOTER //
// ./src/Components/Popup/Popup.jsx